








































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
import daifuordersubmit from "./PayUnusalOrdersEdit.vue";
var that;
@Component({
  components: { daifuordersubmit },
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.PayUnusalOrderServiceProxy();
  }
  refreshsec = 15;
  autorefresh = false;
  pageSize = 50;
  input: proxy.PayUnusalOrderPageInputDto = new proxy.PayUnusalOrderPageInputDto();
  sub_id = 0;
  createOrEditShow = false;
  setcommentorder = {} as any;
  comment = "";
  PayChannels = [];
  createrange = [];
  startMoney = undefined;
  endMoney = undefined;
  columns: any[] = [];
  twidth = 100;
  merchants = [];
  ctypes = [];
  supps = []

  options = {
    shortcuts: [
      {
        text: '今天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
          return [start, end]
        }
      },
      {
        text: '昨天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime());
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24);
          return [start, end]
        }
      },
      {
        text: '三天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 2);
          return [start, end]
        }
      },
      {
        text: '一周',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 6);
          return [start, end]
        }
      }
    ]
  }

  allcolumns: any[] = [
    {
      type: "selection",
      width: 60,
      align: "center",
      title: "选择框",
    },
    {
      title: "系统单号",
      slot: "tid",
      width: 180,
      resizable: true,
    },
    {
      title: "商户单号",
      slot: "merOrderTid",
      width: 180,
      resizable: true,
    },
    {
      title: "商户",
      slot: "merchantName",
      width: 200,
      resizable: true,
    },
    // {
    //   title: "商户号",
    //   slot: "mid",
    //   width: 100,
    // },
    {
      title: "上游通道",
      slot: "channelName",
      width: 230,
      resizable: true,
    },
    // {
    //   title:'通道费率',
    //   slot:'channelRate',
    //   width:110
    // },
    {
      title: "产品",
      slot: "payChannelName",
      width: 230,
      resizable: true,
    },

    {
      title: "金额",
      slot: "money",
      width: 120,
    },

    {
      title: "创建时间",
      key: "creationTime",
      width: 180,
    },
    {
      title: "利润",
      slot: "lirun",
      width: 100,
    },
    {
      title: "手续费",
      slot: "commission",
      width: 100,
    },
    {
      title: '通道代理佣金',
      slot: 'agentRateCommission',
      width: 120
    },
    {
      title: '商户代理佣金',
      slot: 'merchantAgentRateCommission',
      width: 120
    },
    {
      title:'异常原因',
      slot:'errorMsg',
      width:180
    }



  ];

  selecttitles = [];
  editsuccess(e) {
    if (e == 1) {
      let m = that.dataList.find(
        (x) =>
          x.daiFuOrderType == 0 &&
          (x.daiFuPay == 0 || x.daiFuPay == 2) &&
          x.id < this.sub_id
      );
      if (m) {
        setTimeout(() => {
          this.daifusubmit(m);
        }, 200);
      }
    } else {
      this.getpage();
    }
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.input.startMoney = this.startMoney;
    this.input.endMoney = this.endMoney;
    this.prox.queryPageList(this.input).then((x) => {
      if (x.items.length) {
        let midwidth = 0;
        let channelRatewidth = 0;
        let payChannelNamewidth = 0;
        x.items.map(p => {
          let _midwidth = this.pxWidth(p.mid + p.merchantName);
          if (_midwidth > midwidth) {
            midwidth = _midwidth
          }
          let _channelRatewidth = this.pxWidth(p.channelRate + p.channelName);
          if (_channelRatewidth > channelRatewidth) {
            channelRatewidth = _channelRatewidth
          }
          let _payChannelName = this.pxWidth(p.channelTypeCode + p.channelTypeName);
          if (_payChannelName > payChannelNamewidth) {
            payChannelNamewidth = _payChannelName
          }
        })

        let mid_c = this.columns.find(x => x.slot == 'merchantName');
        if (mid_c) {
          mid_c.width = midwidth + 50;
        }

        let channelName_c = this.columns.find(x => x.slot == 'channelName');
        if (channelName_c) {
          channelName_c.width = channelRatewidth + 60;
        }

        let payChannelName_c = this.columns.find(x => x.slot == 'payChannelName');
        if (payChannelName_c) {
          payChannelName_c.width = payChannelNamewidth + 60;
        }

      }
      this.dataList = x.items;
      this.showPaging(x);
    });

  }




  getpage() {
    this.OnInit();
  }
  interv = 0;
  selecttitleschange() {
    this.columns = this.allcolumns.filter((x) =>
      this.selecttitles.includes(x.title)
    );
    localStorage.setItem("unusalordercolumns", JSON.stringify(this.selecttitles));
  }
  beforeMount() {
    let columnscache = localStorage.getItem("unusalordercolumns");
    if (!columnscache) {
      this.columns.push(...this.allcolumns);
      this.selecttitles = this.allcolumns.map((x) => {
        return x.title;
      });
    } else {
      let arr = JSON.parse(columnscache);
      this.selecttitles = arr;
      this.allcolumns.forEach((x) => {
        if (arr.indexOf(x.title) != -1) {
          this.columns.push(x);
        }
      });
    }

  }
  async created() {
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    this.getpage();

    setTimeout(() => {
      let req = new proxy.ChannelSimpleInputDto();
      new proxy.ChannelServiceProxy().queryAllList(req).then((x) => {
        this.PayChannels = x;
      });


      let mreq = new proxy.MerchantSimpleInputDto();
      new proxy.MerchantServiceProxy().queryAllList(mreq).then((x) => {
        this.merchants = x;
      });

      let creq = new proxy.ChannelTypePageInputDto();

      new proxy.ChannelTypeServiceProxy().queryAllTypes(creq).then((x) => {
        this.ctypes = x;
      });

      new proxy.ChannelSupplierServiceProxy().queryAllList().then(x => {
        this.supps = x;
      })
    }, 2000)


  }
  daifusubmit(row) {
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }











}
